import { useEffect } from 'react';
import { CONFIRM_DIALOG, ConfirmDialogType, TooManyRequestsTimer } from './FilterActions.types';

interface UseFilterActionsTooManyRequestsTimerParams {
  tooManyRequestsTimer: TooManyRequestsTimer | undefined;
  setTooManyRequestsTimer: (timer: TooManyRequestsTimer | undefined) => void;
  dialogVisible: ConfirmDialogType | undefined;
  setDialogVisible: (dialog: ConfirmDialogType | undefined) => void;
}

export function useFilterActionsTooManyRequestsTimer({
  tooManyRequestsTimer,
  setTooManyRequestsTimer,
  dialogVisible,
  setDialogVisible
}: UseFilterActionsTooManyRequestsTimerParams): void {
  useEffect(() => {
    if (!tooManyRequestsTimer?.timeLeft) {
      if (tooManyRequestsTimer?.timeLeft === 0) {
        setTooManyRequestsTimer(undefined);
        if (dialogVisible === CONFIRM_DIALOG.TOO_MANY_REQUESTS) {
          setDialogVisible(undefined);
        }
      }
      return undefined;
    }

    const intervalId = setInterval(() => {
      setTooManyRequestsTimer({
        ...tooManyRequestsTimer,
        timeLeft: tooManyRequestsTimer.timeLeft - 1
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [dialogVisible, tooManyRequestsTimer, tooManyRequestsTimer?.timeLeft, setDialogVisible, setTooManyRequestsTimer]);
}
